export class GlobalListeners {
  constructor() {
    this.selectors = {
      quickAdds: '[quick-add-qf]',
      productForm: `[action="${window.Shopify.routes.root}cart/add"]`,
      openSideCart: '.openSideCart',
      closeSideCart: '.closeSideCart',
      removeButtons: '.cart .items-wrapper .item .remove-item',
      quantitySelectorPlus: '.cart .items-wrapper .item .quantity-wrapper .plus',
      quantitySelectorMinus: '.cart .items-wrapper .item .quantity-wrapper .minus',
      quantitySelect: '[quantity-select]',
      quantityPlus: '[quantity-plus]',
      quantityMinus: '[quantity-minus]',
      quantity: '[quantity]',
      cartCount: '.cart-count',
      accordion: 'accordion',
      product_description: '[read-more-container]',
      productCard: '.product-card',
      quickViewCard: '[open-quick-view-card]',
      quickviewCardModal: '.quick-view-card-container',
      quickviewCardClose: '.quick-view-card-container .quick-view-card-close',
      quickviewCardInner: '.quick-view-card-container .quick-view-card-inner',
      mega_menu_images: '.mega-menu .mega-menu-dropdown_outer-wrapper img',
      mega_menu_element: '.mega-menu .top-level-links',
      has_children: '.top-level-link.has-children',
      column_title: '.mega-menu-dropdown_outer-wrapper .column-title',
      newsletter_signup: 'input[name="contact[email]"]',
      footerTitle: '.footer-item .link-title',
      mobileRecommended: '[side-cart-inner] [cart-recommendations]',
      mobileRecommendedHeading: '[side-cart-inner] [cart-recommendations] .heading',
      scentSampleSelect: '.scent-sample select',
      scentMoreInfo: '[scent-more-info]',
      gift_card_fields: '[product-gift-card-fields]',
      send_as_gift_input: '[send_as_gift_input]',
      hide_gift_fields_trigger: '[show_hide_gift_card_fields]',
      choose_value_trigger: '.toggle-gift-card-values[data-option="1"]',
      gift_card_options: '.variant-selector-wrapper.gift-card .radio-option[data-option="1"]'
    };

    this.init();
  }

  init() {
    document.body.addEventListener('click', this.handleEvent.bind(this));
    document.body.addEventListener('submit', this.handleFormSubmit.bind(this));
    document.body.addEventListener('change', this.handleSelectChange.bind(this));
    this.cartRelated();
    this.showMegaMenuImages();
    this.trackNewsletterSignup();
  }

  handleFormSubmit(e) {
    this.productForm(e);
  }

  handleEvent(e) {
    this.headerSearch(e);
    this.productQuickAdd(e);
    this.siteCart(e);
    this.quantityButtons(e);
    this.removeCartItem(e);
    this.accordions(e);
    this.productDescriptions(e);
    this.sideCartTabs(e);
    this.mobileMenu(e);
    this.mobileFooter(e);
    this.quantityPlus(e);
    this.quantityMinus(e);
    this.closeSideCartRecommended(e);
    this.delegateOpenQuickView(e);
    this.delegateCloseQuickView(e);
    this.toggleOrderNote(e);
    this.saveOrderNote(e);
    this.deleteOrderNote(e);

    this.hideGiftCardFields(e);
    this.showGiftCardValue(e);
    this.handleScentSampleClick(e);
    this.scentMoreInfo(e);
  }

  scentMoreInfo(e) {
    const scentMoreInfo = e.target.closest(this.selectors.scentMoreInfo);
    if (scentMoreInfo) {
      const scentInfo = document.querySelector('#try');
      if (!scentInfo.classList.contains('active')) {
        scentInfo.click();
      }
    }
  }

  showGiftCardValue(e) {
    const trigger = e.target.closest(this.selectors.choose_value_trigger);
    if (!trigger) return;

    const options = document.querySelector(this.selectors.gift_card_options);
    if (!options) return;

    // toggle the “choose value” dropdown
    trigger.classList.toggle('active');
    options.classList.toggle('active');

    // only once, when it first opens, bind each radio’s change → update text
    if (options.classList.contains('active') && !options.dataset.listenerAttached) {
      options.dataset.listenerAttached = 'true';
      options
        .querySelectorAll('input[type="radio"][data-value]')
        .forEach(radio => {
          radio.addEventListener('change', () => {
            // grab the chosen label/value
            const chosen = radio.value || radio.dataset.value;
            const span   = trigger.querySelector('span');
            if (span) span.innerText = chosen;

            // close the dropdown again
            options.classList.remove('active');
            trigger.classList.remove('active');
          });
        });
    }
  }

  hideGiftCardFields(e) {
    const hideGiftFieldsTrigger = e.target.closest(this.selectors.hide_gift_fields_trigger);

    if (hideGiftFieldsTrigger) {
      console.log('Hide gift fields');
      const giftCardFields = document.querySelector(this.selectors.gift_card_fields);
      const sendAsGiftInput = document.querySelector(this.selectors.send_as_gift_input);

      if (giftCardFields && sendAsGiftInput) {
        giftCardFields.classList.toggle('hidden');

        // toggle sendAsGiftInput value to false if fields hidden
        if (sendAsGiftInput.value === 'on') {
          sendAsGiftInput.value = 'false';
          sendAsGiftInput.removeAttribute('property');
          // set as disabled
          sendAsGiftInput.setAttribute('disabled', 'disabled');
        } else {
          sendAsGiftInput.value = 'on';
          sendAsGiftInput.setAttribute('property', '');
          // remove disabled attribute
          sendAsGiftInput.removeAttribute('disabled');
        }

        const inputs = giftCardFields.querySelectorAll('input:not([type="hidden"])');
        // removed required and toggle attribute property
        inputs.forEach(input => {
          if (input.hasAttribute('required')) {
            input.removeAttribute('required');
            input.removeAttribute('property');
          } else {
            input.setAttribute('required', 'required');
            input.setAttribute('property', '');
          }
        });
      }
    }
  }

  productQuickAdd(e) {
    // PRODUCT QUICK ADD
    const quickAdd = e.target.closest(this.selectors.quickAdds);
    if (quickAdd) {
      e.preventDefault();
      const quantity = parseInt(quickAdd.dataset.quantity);
      if (quickAdd.dataset.id && quantity > 0) {
        window.cart.add({ items: [{ "id": quickAdd.dataset.id, "quantity": quantity }] });

        quickAdd.classList.add('added');
        setTimeout(() => {
          quickAdd.classList.remove('added');
        }, 2000);
      }
    }
  }

  productForm(e) {
    const productForm = e.target.closest(this.selectors.productForm);

    if (productForm) {
      e.preventDefault();

      const product_id = productForm.getAttribute("id").split("_").pop();

      const quantity_el = productForm.querySelector("[quantity-select] input[type='number']");
      let quantity = 1;
      if (quantity_el) {
        quantity = parseInt(quantity_el.value);
      }

      // Try to get section_id from form or fallback to parent .product-form wrapper
      let section_id = productForm.getAttribute("data-section-id");
      if (!section_id) {
          const wrapper = productForm.closest('.product-form');
          if (wrapper) {
              section_id = wrapper.getAttribute("data-section-id");
          }
      }

      if (!section_id) {
          console.error("Missing data-section-id on form or wrapper for product", product_id);
          return;
      }

      let idInput =
        productForm.querySelector(`#product-id-${section_id}-${product_id}`) ||
        productForm.querySelector('input[name="id"]');

      if (!idInput) {
        console.error(
          `Unable to find a variant input in form (tried both select and hidden input)`
        );
        return;
      }

      const id = idInput.value;

      let properties = {};
      const propertyFields = productForm.querySelectorAll('.property');

      if (propertyFields) {
        propertyFields.forEach(field => {
          const key = field.getAttribute('name');
          const value = field.value;
          if (key && value) {
            properties[key] = value;
          }
        });
      }

      // free sample scent
      // Check if product is a scent sample
     let hasScentSampleId = null;
      const freeSample = productForm.querySelector('[data-try-first]');
      if (freeSample) {
        const qualifiyingIds = freeSample.getAttribute('data-try-first');
        const freeSampleId = freeSample.getAttribute('data-try-first-variant');

        if (qualifiyingIds && freeSampleId) {
          const ids = qualifiyingIds.split(',').map(id => id.trim());
          if (ids.includes(id)) {
            // If the product is a qualifying scent sample, add the free sample
            hasScentSampleId = freeSampleId;
          }
        }
      }

      // Check if user selected a scent sample
      const scentSelect = document.querySelector('.scent-sample-select');
      const selectedScentId = scentSelect?.value;
      const scentSampleButton = document.querySelector('.fake-sample-button.added');

      // Check for Product Add Ons
      const productAddOnWrapper = productForm.querySelector('[product-add-ons]');
      let productAddOnId = null;
      let productAddOnCartDescription = null;

      if (productAddOnWrapper) {
        const productAddOn = productAddOnWrapper.querySelector('input[type="radio"]:checked');
        if (productAddOn) {
          productAddOnId = productAddOn.dataset.id;
          productAddOnCartDescription = productAddOn.dataset.cartDescription;
        }
      }

      let cartAddObject = [{ id, quantity, properties }];

      if (productAddOnId) {
        cartAddObject.push({ id: productAddOnId, quantity, properties: { _parent_id: product_id, _add_on_product: true, cart_description: productAddOnCartDescription } });
      }

      if (quantity && id) {
        window.cart.add({
          items: cartAddObject
        }).then(() => {
          if (selectedScentId && scentSampleButton && hasScentSampleId) {
            return new Promise((resolve) => {
              setTimeout(() => {
                window.cart.add({
                  items: [{
                id: hasScentSampleId,
                quantity: 1,
                properties: {
                  _related_to_product: product_id
                }
              }, {
                id: selectedScentId,
                quantity: 1
              }]
                }).then(resolve);
              }, 200);
            });
          } else if (selectedScentId && scentSampleButton) {
            return window.cart.add({
              items: [{
                id: selectedScentId,
                quantity: 1,
                properties: {
                  _related_to_product: product_id
                }
              }]
            });
          } else if (hasScentSampleId) {
            return window.cart.add({
              items: [{
                id: hasScentSampleId,
                quantity: 1,
                properties: {
                  _related_to_product: product_id
                }
              }]
            });
          }
        }).then(() => {
          // Close quickview card after successful form submission
          this.closeQuickViewCardAfterSubmit(productForm);
        }).catch((err) => {
          console.error('Error adding product(s) to cart:', err);
        });
      }

    }
  }

  siteCart(e) {
    // SITE CART OPEN AND CLOSE
    if (!window.QF.settings.sideCart) return;

    const openSideCart = e.target.closest(this.selectors.openSideCart);
    if (openSideCart) {
      e.preventDefault();
      window.cart.openSideCart();
    }

    const closeSideCart = e.target.closest(this.selectors.closeSideCart);
    if (closeSideCart) {
      e.preventDefault();
      window.cart.closeSideCart();
    }

    if (e.target.classList.contains('cart-drawer-container')){
      window.cart.closeSideCart();
    }
  }

  closeSideCartRecommended(e) {
    const closeBtn = e.target.closest('[close-side-cart-recommended]');
    if (closeBtn) {
      e.preventDefault();
      window.cart.closeSideCartRecommended();
    }
  }

  quantityButtons(e) {
    // QUANTITY PLUS CART
    const quantityPlus = e.target.closest(this.selectors.quantitySelectorPlus);
    if (quantityPlus) {
      if (quantityPlus.getAttribute("data-pending") === "true") return;
      quantityPlus.setAttribute("data-pending", true);

      const quantityElement = quantityPlus.parentNode.querySelector(".quantity span");
      const stock = quantityElement.getAttribute("data-stock");
      const current = parseInt(quantityElement.innerHTML);
      const variant_key = quantityElement.closest('.item').getAttribute("data-variant-key");
      const inv_policy = quantityElement.getAttribute("data-inventory-policy");
      if (inv_policy === "deny" && stock == 0) {
        // if out of stock, show out of stock message
        const quantity_limit_title = quantityElement.getAttribute("data-quantity-limit-title");
        const quantity_limit_message = quantityElement.getAttribute("data-quantity-limit-message");
        if (quantity_limit_title && quantity_limit_message) {
          const options = {
            title: quantity_limit_title,
            message: quantity_limit_message + " " + quantityElement.innerHTML,
            delay: 1000
          }
          window.toasty.addToast(options);
        }
      } else if (inv_policy === "continue" || stock > 0) {
        // if in stock or continue selling when out of stock, update cart
        const updated = current + 1;
        window.cart.change({ "id": variant_key, "quantity": updated });
      }
    }

    // QUANTITY MINUS CART
    const quantityMinus = e.target.closest(this.selectors.quantitySelectorMinus);
    if (quantityMinus) {
      if (quantityMinus.getAttribute("data-pending") === "true") return;
      quantityMinus.setAttribute("data-pending", true);

      const quantity = quantityMinus.parentNode.querySelector(".quantity span");
      const current = parseInt(quantity.innerHTML);
      const variant_key = quantity.closest('.item').getAttribute("data-variant-key");

      if (current > 0) {
        const updated = current - 1;
        window.cart.change({ "id": variant_key, "quantity": updated });
      }
    }
  }

  quantityPlus(e) {
    const plus = e.target.closest(this.selectors.quantityPlus);

    if (plus) {
      const quantity_input = plus.closest(this.selectors.quantitySelect).querySelector("input[type='number']");
      const quantity = plus.closest(this.selectors.quantitySelect).querySelector(this.selectors.quantity);
      const new_value = parseInt(quantity_input.value) + 1;
      const max = quantity_input.getAttribute("max");
      const max_quantity_title = quantity_input.getAttribute("data-max-quantity-title");
      const max_stock_message = quantity_input.getAttribute("data-max-quantity-message") + " " + max;

      if (new_value <= max) {
        quantity_input.value = new_value;
        quantity.innerHTML = new_value;
      }

      if (new_value > max && max_stock_message && max_quantity_title) {
        const options = {
          title: max_quantity_title,
          message: max_stock_message,
          delay: 2000
        }
        window.toasty.addToast(options);
      }

    }
  }

  quantityMinus(e) {
    const minus = e.target.closest(this.selectors.quantityMinus);

    if (minus) {
      const quantity_input = minus.closest(this.selectors.quantitySelect).querySelector("input[type='number']");
      const quantity = minus.closest(this.selectors.quantitySelect).querySelector(this.selectors.quantity);
      const new_value = parseInt(quantity_input.value) - 1;

      if (new_value > 0) {
        quantity_input.value = new_value;
        quantity.innerHTML = new_value;
      }
    }
  }

  removeCartItem(e) {
    // REMOVE ITEM CART
    const removeButtons = e.target.closest(this.selectors.removeButtons);
    if (removeButtons) {
      const variant_key = removeButtons.closest('.item').getAttribute("data-variant-key");
      window.cart.change({ "id": variant_key, "quantity": 0});
    }
  }

  cartRelated() {
    // update side cart/cart after change
    const renderCarts = () => {
      if (window.template === "cart") {
        window.cart.reRenderCart();
      } else {
        if (window.QF.settings.ajax_open_side_cart) {
          window.cart.openSideCart();
        } else if (window.QF.settings.ajax_toast) {
          window.cart.reRenderSideCart();
        }
      }
    };
    window.addEventListener("cart_changed", renderCarts);
    window.addEventListener("item_removed", renderCarts);

    // CART COUNT
    window.addEventListener("cart_changed", e => {
      if (e.detail.cart) {
        const cartCount = document.querySelectorAll(".cart-count");
        cartCount.forEach(count => {
          count.innerHTML = e.detail.cart.item_count;
        });
      }
    });
  }

  headerSearch(e) {
    const search            = document.querySelector('.predictive-search-container .predictive-search-bar');
    const searchTrigger     = document.querySelector('.mega-menu [data-open-search]');
    const predictiveSearch  = document.querySelector('.predictive-search-container');
    const recommendedContainer = predictiveSearch.querySelector('.inner.recommended-inner');

    if (!search) return;
    const target = e.target;

    if (
      target === searchTrigger ||
      target.closest('.search-trigger') ||
      target.closest('[data-open-search]') ||
      (target.closest('.predictive-search-container') && !target.closest('.close-predictive-search'))
    ) {
      if (!searchTrigger.classList.contains('active')) {
        searchTrigger.classList.add('active');
        predictiveSearch.classList.add('active');
        search.classList.add('active');
        target.focus();
      }
    } else {
      searchTrigger.classList.remove('active');
      search.classList.remove('active');
      recommendedContainer.style.display = 'none';
      predictiveSearch.classList.remove('active');
    }

    if (e.key === 'Escape' && searchTrigger.classList.contains('active')) {
      searchTrigger.classList.remove('active');
      search.classList.remove('active');
      recommendedContainer.style.display = 'none';
      predictiveSearch.classList.remove('active');
    }
  }

  mobileMenu(e) {
    const menu = document.querySelector('.top-level-links-wrapper .top-level-links');
    const menuTrigger = document.querySelector('#open-mobile-menu');
    const body = document.body;

    if (menuTrigger && e.target.closest('#open-mobile-menu')) {
      if (menuTrigger.classList.contains('active')) {
        menu.classList.remove('active');
        menuTrigger.classList.remove('active');
        body.classList.remove('mobile-menu-opened');
        body.classList.remove('fixed');
      } else {
        menu.classList.add('active');
        menuTrigger.classList.add('active');
        body.classList.add('mobile-menu-opened');
        body.classList.add('fixed');
      }
    }

    // Mobile has children
    const hasChildren = e.target.closest(this.selectors.has_children);
    if (hasChildren && window.innerWidth < 1024) {
      e.preventDefault();
      hasChildren.classList.toggle('active');
    }

    // Mobile column titles
    const columnTitle = e.target.closest(this.selectors.column_title);
    if (columnTitle && window.innerWidth < 1024) {
      e.preventDefault();
      columnTitle.parentElement.classList.toggle('active');
    }

    if (e.target === menu) {
      menu.classList.remove('active');
      menuTrigger.classList.remove('active');
    }

    // Mobile recommended products
    const mobileRecommended = e.target.closest(this.selectors.mobileRecommended);
    const mobileRecommendedHeading = e.target.closest(this.selectors.mobileRecommendedHeading);

    if (mobileRecommendedHeading) {
      mobileRecommended.classList.toggle('active');
    }
  }

  mobileFooter(e) {
    const footerTitle = e.target.closest(this.selectors.footerTitle);
    if (footerTitle) {
      footerTitle.parentElement.classList.toggle('active');
    }
  }

  sideCartTabs(e) {
    if (e.target && e.target.closest) {
      const cartTab = e.target.closest('.cart-tab');

      if (cartTab && !cartTab.classList.contains('active')) {

        const cartTabs = document.querySelectorAll('.cart-tab');

        cartTabs.forEach(tab => {
          tab.classList.remove('active');
        });

        let tabSelected = cartTab;
        tabSelected.classList.add('active');
        let tabData = tabSelected.getAttribute('data-tab');
        let cartContents = document.querySelectorAll('.cart-content');

        cartContents.forEach(cartContent => {
          cartContent.style.display = 'none';
        });

        document.querySelector('.' + tabData).style.display = 'flex';
      }
    }
  }

  accordions(e) {
    if (e.target.classList.contains(this.selectors.accordion) ) {
      e.preventDefault();

      const accordion = e.target;
      const parent = accordion.parentElement;
      const sibling_accordions = parent.getElementsByClassName(this.selectors.accordion);
      const panel = accordion.nextElementSibling;


      if ( sibling_accordions ) {
        Array.from(sibling_accordions).forEach((acc) => {
          if ( acc != accordion || accordion.classList.contains('active') ) {
            acc.nextElementSibling.style.maxHeight = null;
            acc.classList.remove("active");
            acc.nextElementSibling.classList.remove("active");

          } else {
            accordion.classList.add("active");
            accordion.nextElementSibling.classList.add("active");
            panel.style.maxHeight = panel.scrollHeight + "px";
          }
        });
      }

    }
  }

  productDescriptions(e) {
      if ( e.target.classList.contains('read-more') ) {
        let el = e.target;

        if (el.classList.contains("active")) {
          el.classList.remove("active");
          el.closest(this.selectors.product_description).classList.remove("active");
          if (el.dataset.readMoreText != "") {
            el.innerHTML = el.dataset.readMoreText;
          }
        } else {
          el.classList.add("active");
          el.closest(this.selectors.product_description).classList.add("active");
          if (el.dataset.readLessText != "") {
            el.innerHTML = el.dataset.readLessText;
          }
        }

      }

  }

  delegateOpenQuickView(e) {
    const quickViewBtn = e.target.closest(this.selectors.quickViewCard);
    if (!quickViewBtn) return;
    e.preventDefault();
    this.openQuickViewCard(e);
  }

  delegateCloseQuickView(e) {
    const closeBtn = e.target.closest(this.selectors.quickviewCardClose);
    if (!closeBtn) return;
    e.preventDefault();
    this.closeQuickViewCard(e);
  }

  openQuickViewCard(e) {
    const quickViewCard = e.target.closest(this.selectors.quickViewCard);

    document.querySelectorAll(this.selectors.quickviewCardModal).forEach(quickViewRemove => {
      if (quickViewRemove.classList.contains('active')) {

        if (quickViewRemove.closest(this.selectors.productCard)) {
          quickViewRemove.closest(this.selectors.productCard).classList.remove('qv-active');
        }
        
        quickViewRemove.classList.remove('active');
        quickViewRemove.querySelector('.quick-view-card-inner').innerHTML = "";
      }
    });

    if (quickViewCard) {
      e.preventDefault();

      setTimeout(async () => {
        // Find the closest modal to the clicked product card
        const closestProductCard = quickViewCard.closest(this.selectors.productCard);
        if (closestProductCard) {
          closestProductCard.classList.add('qv-active');
        }

        const quickviewCardModal = quickViewCard.closest(this.selectors.productCard).querySelector(this.selectors.quickviewCardModal);
        if (!quickviewCardModal) {
          console.error('quickviewCardModal not found');
          return;
        }

        let quickViewCardModalInner = quickviewCardModal.querySelector(".quick-view-card-inner");
        if (!quickViewCardModalInner) {
          console.error('quickViewCardModalInner not found');
          return;
        }

        let sectionName = "fs-product-qv-card";
        let handle = quickViewCard.getAttribute("data-product-handle");
        if (handle) {
          try {
            const response = await fetch(window.Shopify.routes.root + `products/${handle}?sections=${sectionName}`);

            if (response.ok) {

              const data = await response.json();
              let html = data[`${sectionName}`];

              const scripts_to_run = html.match(/<script qv-run>([\s\S]*?)<\/script>/gm) || [];
              const scripts = [];

              scripts_to_run.forEach(script => {
                  script = script.replace("</script>", "").replace("<script qv-run>", "");
                  scripts.push(script);
              });

              if (html) {

                if (window.innerWidth < 768) {
                  document.body.appendChild(quickviewCardModal);
                }
                
                quickViewCardModalInner.innerHTML = html;

                scripts.forEach(script_to_eval => {
                  new Function(script_to_eval)();
                });

                if (window.yotpo && typeof window.yotpo.refreshWidgets === 'function') {
                  window.yotpo.refreshWidgets();
                } else if (window.yotpo && typeof window.yotpo.initWidgets === 'function') {
                  // some older/newer Yotpo versions expose initWidgets()
                  window.yotpo.initWidgets();
                }

                quickviewCardModal.classList.add("active");

                // Store direct reference to the original product card element
                quickviewCardModal.originalProductCard = closestProductCard;

                this.productForm(e);
                
              }
            } else {
              throw new Error('Error: ' + response.status);
            }
          } catch (error) {
            console.error(error);
          }
        }
      }, 0);
    }
  }

  closeQuickViewCard(e) {
    const quickviewCardClose = e.target.closest(this.selectors.quickviewCardClose);

    if (quickviewCardClose) {
      e.preventDefault();

      const quickviewCardModal = quickviewCardClose.closest(this.selectors.quickviewCardModal);
      const originalProductCard = quickviewCardModal.originalProductCard;

      if (quickviewCardModal && originalProductCard) {
        originalProductCard.classList.remove('qv-active');
        quickviewCardModal.classList.remove("active");
        quickviewCardModal.querySelector('.quick-view-card-inner').innerHTML = "";

        // Move back to product card if on mobile
        if (window.innerWidth < 768) {
          originalProductCard.appendChild(quickviewCardModal);
        }

        // Clean up the DOM reference to prevent potential memory leaks
        delete quickviewCardModal.originalProductCard;

      } else {
        console.error('Original product card DOM reference not found.');
      }
    }
  }

  closeQuickViewCardAfterSubmit(productForm) {
    // Find the quickview card modal that contains this form
    const quickviewCardModal = productForm.closest(this.selectors.quickviewCardModal);
    
    if (quickviewCardModal) {
      const originalProductCard = quickviewCardModal.originalProductCard;
      
      if (originalProductCard) {
        originalProductCard.classList.remove('qv-active');
        quickviewCardModal.classList.remove("active");
        quickviewCardModal.querySelector('.quick-view-card-inner').innerHTML = "";

        // Move back to product card if on mobile
        if (window.innerWidth < 768) {
          originalProductCard.appendChild(quickviewCardModal);
        }

        // Clean up the DOM reference to prevent potential memory leaks
        delete quickviewCardModal.originalProductCard;
      } else {
        console.error('Original product card DOM reference not found.');
      }
    }
  }

  showMegaMenuImages() {
    const mega_menu_element = document.querySelector(this.selectors.mega_menu_element);
    const mega_menu_images = document.querySelectorAll(this.selectors.mega_menu_images);
    this.loadImagesOnMouseEnter(mega_menu_images,mega_menu_element);
  }

  loadImagesOnMouseEnter(images, hover_element) {
    if (!images) {
      console.log('No images found');
      return;
    }
    if (!hover_element) {
      console.log('No hover element found');
      return;
    }

    const loadImages = () => {
      images.forEach(image => {
        const src = image.getAttribute('data-src');
        if (src) {
          image.src = src;
        }
      });
    };

    // Run once if already hovered
    if (hover_element.matches(':hover')) {
      loadImages();
    } else {
      // Otherwise wait for first hover
      hover_element.addEventListener('mouseenter', loadImages, { once: true });
    }
  }

  trackNewsletterSignup() {
    const emailInput = document.querySelector(this.selectors.newsletter_signup);

    if (!emailInput) return;

    const handleEmailInput = (email) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (email && emailRegex.test(email)) {
        try {
          if (typeof klaviyo !== 'undefined' && klaviyo.identify) {
            klaviyo.identify({ email });
          } else {
            console.warn('Klaviyo is not available on the site.');
          }
        } catch (error) {
          console.error('Error identifying user with Klaviyo:', error);
        }
      }
    };

    const debounce = (func, delay) => {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), delay);
      };
    };

    emailInput.addEventListener(
      'input',
      debounce((e) => handleEmailInput(e.target.value), 500)
    );

    emailInput.addEventListener('blur', (e) => handleEmailInput(e.target.value));
  }

  handleSelectChange(e) {
    this.updateScentQuickAdd(e);
  }

  handleScentSampleClick(e) {
    const button = e.target.closest('.fake-sample-button');
    if (!button) return;

    const wrapper = button.closest('.scent-sample');
    const select = wrapper && wrapper.querySelector('.scent-sample-select');

    if (!select) return;

    // If already added, remove selection
    if (button.classList.contains('added')) {
      button.classList.remove('added');
      select.selectedIndex = 0;
      button.setAttribute('disabled', '');
      console.log('🚫 Scent sample deselected');
    } else if (select.value) {
      button.classList.add('added');
      console.log('✅ Scent sample selected variant ID:', select.value);
    }
  }

  updateScentQuickAdd(e) {
    const select = e.target;
    if (!select.matches(this.selectors.scentSampleSelect)) return;

    const wrapper = select.closest('.scent-sample');
    const fakeAdd = wrapper && wrapper.querySelector('.fake-sample-button');

    // Only enable the button — do NOT add class or log anything yet
    if (fakeAdd) {
      if (select.value && select.selectedIndex !== 0) {
        fakeAdd.removeAttribute('disabled');
        fakeAdd.classList.remove('added'); // ensure we reset it
      } else {
        fakeAdd.setAttribute('disabled', '');
        fakeAdd.classList.remove('added');
      }
    }
  }

  toggleOrderNote(e) {
    const btn = e.target.closest('.js-add-order-note');
    if (!btn) return;

    e.preventDefault();
    const container = btn.closest('.cart-extras__order-note');
    const noteBlock = container.querySelector('.order-note');

    // Show/hide the textarea block
    const isOpen = noteBlock.style.display !== 'none';
    noteBlock.style.display = isOpen ? 'none' : 'block';

    // Change add/edit text
    if (!isOpen) {
      btn.textContent = btn.classList.contains('has-note')
        ? 'Edit order note'
        : 'Add order note';
    } else {
      btn.textContent = btn.classList.contains('has-note')
        ? 'Edit order note'
        : 'Add order note';
    }
  }

  saveOrderNote(e) {
    const saveBtn = e.target.closest('.js-save-order-note');
    if (!saveBtn) return;

    e.preventDefault();
    const container = saveBtn.closest('.cart-extras__order-note');
    const textarea = container.querySelector('#CartOrderNote');
    const note = textarea.value.trim();

    window.cart.updateNote(note)
      .then(() => {
        // mark that we now have a note
        const toggleBtn = container.querySelector('.js-add-order-note');
        toggleBtn.classList.add('has-note');
        toggleBtn.textContent = 'Edit order note';
        container.querySelector('.order-note').style.display = 'none';
      })
      .catch(err => console.error(err));
  }

  deleteOrderNote(e) {
    const delBtn = e.target.closest('.js-delete-order-note');
    if (!delBtn) return;

    e.preventDefault();
    const container = delBtn.closest('.cart-extras__order-note');
    const textarea = container.querySelector('#CartOrderNote');

    // clear locally
    textarea.value = '';
    window.cart.updateNote('')
      .then(() => {
        // remove the “has-note” flag
        const toggleBtn = container.querySelector('.js-add-order-note');
        toggleBtn.classList.remove('has-note');
        toggleBtn.textContent = 'Add order note';
        container.querySelector('.order-note').style.display = 'none';
      })
      .catch(err => console.error(err));
  }

}

// window.GlobalListeners = GlobalListeners;

